<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="选择设备" >
						<el-select v-model="queryParams.deviceId" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
							:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true" @change="deviceChange">
							<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="任务名称"><el-input v-model="queryParams.title" placeholder="任务名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery" >查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd" v-has="'btn_add'">添加</el-button>
						<el-button type="danger" size="small" @click="batchDelete"  v-has="'btn_del'">批量删除</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column fixed type="selection" width="55"  v-if="showSelection"></el-table-column>
					<el-table-column sortable="custom" prop="title" label="任务名称"></el-table-column>
					<el-table-column sortable="custom" prop="deviceTitle" label="执行设备"></el-table-column>
					<el-table-column sortable="custom" prop="executionMode" label="执行方式">
						<template slot-scope="scope">
							{{scope.row.executionMode | formatExecutionMode}}
						</template>
					</el-table-column>
					<el-table-column prop="state" label="任务状态" width="130px" >
						<template slot-scope="scope">
							<el-switch v-model="scope.row.stateSw" @change="statusSwChange(scope.row)"  v-if="hashState"></el-switch>
							<span v-else>{{scope.row.state |formatState}}</span>
						</template>
					</el-table-column>
					<el-table-column sortable="custom" prop="updateTime" label="更新时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)"  v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" type="danger" @click="batchUpdateStatus(-1,'删除',scope.row.id)"  v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false" :lock-scroll="true" top="30px">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="任务名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title" style="width: 300px;"></el-input></el-form-item>
				<el-form-item label="选择设备" prop="deviceId">
					<el-select v-model="addOrUpdateForm.deviceId" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList" :loading="deviceLoading"
						@focus="deviceSelectFocus" :clearable="true" @change="deviceChange" style="width: 300px;">
						<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="执行方式" prop="executionMode">
					<el-radio-group v-model="addOrUpdateForm.executionMode" @change="executionModeChange">
						<el-radio label="repeat">重复执行</el-radio>
						<el-radio label="single">单次执行</el-radio>
						<el-radio label="interval">按时间间隔循环执行</el-radio>
					</el-radio-group>
					</el-select>
				</el-form-item>
				<el-button size="mini" type="primary" @click="handleAddContent" style="margin-bottom: 10px;">添加内容</el-button>
				<el-table v-loading="loading" :data="filteredContentList" stripe border style="width: 100%;" ref="multipleTable" tooltip-effect="dark" @sort-change="sortChange"
					:default-sort="queryParams.defaultSort" max-height="400">
					<el-table-column prop="variableId" label="选择变量" width="160px">
						<template slot-scope="scope">
							<el-select  size="mini" v-model="scope.row.variableId" filterable remote reserve-keyword placeholder="请选择变量" :remote-method="queryTemplateVariableList"
								:loading="templateVariableLoading" @focus="templateVariableSelectFocus(scope.row)" :clearable="true" @change="templateVariableChange(scope.row)">
								<el-option v-for="item in templateVariableList" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="operateType" label="执行操作" width="140px">
						<template slot-scope="scope">
							<el-radio-group  size="mini" v-model="scope.row.operateType">
								<el-radio-button :label="1">采集</el-radio-button>
								<el-radio-button :label="2">下发</el-radio-button>
							</el-radio-group>
						</template>
					</el-table-column>
					<el-table-column prop="sendData" label="发送数据" width="160px">
						<template slot-scope="scope">
							<el-input-number  size="mini" type="number" :disabled="scope.row.operateType==1" v-model="scope.row.sendData" :controls="false" :max="65536"
								:clearable="true"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="executionDays" label="执行日期" v-if="addOrUpdateForm.executionMode=='repeat'"  key="repeat">
						<template slot-scope="scope">
							<el-select size="mini" v-model="scope.row.executionDays" style="width: 100px;">
								<el-option label="星期一" :value="1"></el-option>
								<el-option label="星期二" :value="2"></el-option>
								<el-option label="星期三" :value="3"></el-option>
								<el-option label="星期四" :value="4"></el-option>
								<el-option label="星期五" :value="5"></el-option>
								<el-option label="星期六" :value="6"></el-option>
								<el-option label="星期日" :value="7"></el-option>
							</el-select>
							<el-select size="mini" v-model="scope.row.executionHour" style="width: 70px;">
								<el-option :key="hour" :label="hour.toString().padStart(2, '0')" :value="hour" v-for="hour in 23"></el-option>
							</el-select>
							时
							<el-select size="mini" v-model="scope.row.executionMinute" style="width: 70px;">
								<el-option :key="minute" :label="minute.toString().padStart(2, '0')" :value="minute" v-for="minute in 59"></el-option>
							</el-select>
							分
						</template>
					</el-table-column>
					<el-table-column prop="executionStartTime" label="执行时间" v-else-if="addOrUpdateForm.executionMode=='single'"  key="single">
						<template slot-scope="scope">
						  <el-date-picker size="mini" v-model="scope.row.executionStartTime" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择时间"> </el-date-picker>
						</template>
					</el-table-column>
					<el-table-column prop="executionMinute" label="执行时间" v-else key="interval">
						<template slot-scope="scope">
							<el-date-picker size="mini" v-model="scope.row.executionTimes" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间"
							end-placeholder="结束时间" align="right" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
							每间隔
							<el-input-number size="mini" type="number" style="width: 60px;" v-model="scope.row.executionMinute" :controls="false" :min="1" :max="1440" :clearable="true"></el-input-number>
							分钟执行一次
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="50">
						<template slot-scope="scope">
							<el-button size="mini" type="text" @click.native.prevent="deleteContent(scope.$index, addOrUpdateForm.contents)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>



			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'scheduled/task',
				name: '定时任务',
				addOrUpdateForm: {},
				deviceList: [],
				deviceLoading: false,
				queryDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				queryTemplateVariableParams: {
					currentPage: 1,
					pageSize: 3000,
					defaultSort: {}
				},
				dialogTemplateVariableVisible: false,
				templateVariableList: [],
				templateVariableLoading: false,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7
					}
				},
				rules: {
					institutionId: [{
							required: true,
							message: '请输入所属机构',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					title: [{
							required: true,
							message: '请输入任务名称',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					deviceId: [{
							required: true,
							message: '请输入设备id',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					deviceTitle: [{
							required: true,
							message: '请输入设备名称',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					],
					executionMode: [{
							required: true,
							message: '请输入执行方式(repeat-重复执行 single-单词 interval-按时间间隔循环执行)',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					state: [{
							required: true,
							message: '请输入状态',
							trigger: 'blur'
						},
						{
							max: 11,
							message: '长度最长支持11',
							trigger: 'blur'
						}
					],
				}
			};
		},
		computed: {
			filteredContentList() {
				console.log(2)
				if (this.addOrUpdateForm.contents) {
					return this.addOrUpdateForm.contents.filter(item => item.state != -1);
				}
			}
		},
		filters: {
			formatExecutionMode(mode) {
				if (mode == 'repeat') {
					return '重复执行'
				}
				if (mode == 'single') {
					return '单次执行'
				}
				if (mode == 'interval') {
					return '按时间间隔循环执行'
				}
			}
		},
		methods: {
			executionModeChange(){
				this.$forceUpdate(); 
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			beforeList(datas){
				if(datas){
					datas.forEach(item=>{
						if(!item.contents){
							item.contents=[]
						}
					})
				}
			},
			handleAdd(){
				this.handleEdit({
					title:"",
					contents:[],
					deviceId:"",
					executionMode:'repeat'
				})
			},
			handleEdit(row) {
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(row);
				this.title = '编辑' + this.name;
				if(this.addOrUpdateForm.id){
					this.queryContentList((datas)=>{
						if (datas) {
							this.addOrUpdateForm.contents = datas;
							this.initSelect()
						}else{
							this.addOrUpdateForm.contents =[]
						}
						this.dialogVisible = true;
					})
				}else{
					this.initSelect()
					this.handleAddContent();
					this.dialogVisible = true;
				}
			},
			initSelect(){
				if(this.addOrUpdateForm.deviceId){
					this.deviceList = [{
						id:this.addOrUpdateForm.deviceId,
						title:this.addOrUpdateForm.deviceTitle
					}]
					if(this.addOrUpdateForm.contents){
						var variableList = []
						var variableKeys=[]
						this.addOrUpdateForm.contents.forEach(item => {
							if(item.variableId){
								if(!variableKeys.includes(item.variableId)){
									variableList.push({
										id:item.variableId,
										title:item.variableTitle
									})
									variableKeys.push(item.variableId)
								}
							}
						});
						if(variableList){
							this.templateVariableList = variableList
						}
					}
				}
			},
			queryContentList(callback) {
				let that = this;
				this.$http({
					method: 'GET',
					url: 'scheduled/task/getContents?id=' + this.addOrUpdateForm.id
				}).then(function(res) {
					if(callback){
						callback(res.data.data)
					}
				})

			},
			beforeUpdate() {
				
			},
			handleAddContent() {
				this.addOrUpdateForm.contents.push({
					variableId: null,
					operateType: 1,
					executionDays: 1,
					executionHour: 1,
					executionMinute: 1
				})
			},
			deleteContent(index, rows) {
				if (rows[index].id) {
					rows[index].state = -1
				} else {
					rows.splice(index, 1);
				}
			},
			deviceSelectFocus() {
				this.queryDeviceList()
			},
			deviceChange() {
				if(this.dialogVisible){
					if (this.addOrUpdateForm.deviceId) {
						let device = this.deviceList.find((item) => item.id === this.addOrUpdateForm.deviceId);
						this.addOrUpdateForm.templateId = device.templateId
						this.addOrUpdateForm.deviceTitle = device.title
					} else {
						this.addOrUpdateForm.templateId = null
					}
					this.addOrUpdateForm.contents.forEach(item => {
						item.variableId = null
					});
				}
			},
			templateVariableChange(row) {
				if (row.variableId) {
					let variable = this.templateVariableList.find((item) => item.id === row.variableId);
					row.variableTitle = variable.title
				}
				this.$forceUpdate(); // 强制重新渲染当前组件
			},
			queryDeviceList(query) {
				let that = this;
				this.deviceLoading = true;
				this.queryDeviceParams.title = query;
				this.$http({
					method: 'POST',
					url: 'devices/query',
					data: this.queryDeviceParams,
				}).then(function(res) {
					that.deviceList = res.data.data;
					that.deviceLoading = false
				})
			},
			templateVariableSelectFocus(row) {
				this.queryTemplateVariableList()
				if (!this.addOrUpdateForm.templateId) {
					row.variableId = null
				}
			},
			queryTemplateVariableList(query) {
				let that = this;
				this.queryTemplateVariableParams.title = query;
				if (this.addOrUpdateForm.templateId) {
					this.templateVariableLoading = true;
					this.queryTemplateVariableParams.templateId = this.addOrUpdateForm.templateId;
					this.$http({
						method: 'POST',
						url: 'template/variable/query',
						data: this.queryTemplateVariableParams,
					}).then(function(res) {
						that.templateVariableList = res.data.data;
						that.templateVariableLoading = false
					})
				} else {
					that.templateVariableList = []
					//this.queryParams.variableId = null
				}
			}
		},
		mounted: function() {
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/scheduledTask.vue